import { requestGet } from '@/common/request';
export default {
  async zongcuParticipatedList(query) {
    return await requestGet('/zongcu/participatedList', query);
  },
};
